import React, { FC } from "react";
import { Button } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import "./MiniPaginator.scss";

export interface MiniPaginatorProps {
  page: number;
  pages: number;
  hasPrev: boolean;
  hasNext: boolean;
  onChange: (page: number) => void;
  className?: string;
  /** 与 VoiceLibraryWorkspacePage 底部分页条一致的「上一页 | 当前页 | 下一页」样式 */
  variant?: "default" | "workspace";
}

export const MiniPaginator: FC<MiniPaginatorProps> = ({
  page,
  pages,
  hasPrev,
  hasNext,
  onChange,
  className,
  variant = "default",
}) => {
  const handlePrev = () => {
    if (hasPrev) onChange(page - 1);
  };

  const handleNext = () => {
    if (hasNext) onChange(page + 1);
  };

  if (variant === "workspace") {
    return (
      <div
        className={`mini-pagination mini-pagination--workspace ${className || ""}`.trim()}
        role="navigation"
        aria-label="分页"
      >
        <button
          type="button"
          className="mini-pagination__nav-btn"
          disabled={!hasPrev}
          aria-label="上一页"
          onClick={handlePrev}
        >
          <LeftOutlined />
        </button>
        <button
          type="button"
          className="mini-pagination__nav-btn mini-pagination__nav-btn--current"
          aria-current="page"
          tabIndex={-1}
        >
          {page}
        </button>
        <button
          type="button"
          className="mini-pagination__nav-btn"
          disabled={!hasNext}
          aria-label="下一页"
          onClick={handleNext}
        >
          <RightOutlined />
        </button>
      </div>
    );
  }

  return (
    <div className={`mini-pagination ${className || ""}`.trim()}>
      <Button className="mini-page-btn" disabled={!hasPrev} onClick={handlePrev} size="small">
        <i className="fas fa-chevron-left"></i>
      </Button>

      <span className="mini-page-info">
        {page} / {pages}
      </span>

      <Button className="mini-page-btn" disabled={!hasNext} onClick={handleNext} size="small">
        <i className="fas fa-chevron-right"></i>
      </Button>
    </div>
  );
};

export default MiniPaginator;
